var BD = typeof BD === 'object' ? BD : {};

//----------------------------------------------------
// BD Cart Queue Methods
//----------------------------------------------------
BD.Cart = {};
BD.Cart.Queue = {};
BD.Cart.Queue.Items = [];
BD.Cart.Queue.Add = function(item) {
	BD.Cart.Queue.Items.push(item);
	console.log("BD.Cart.Queue.Add");
	//console.log(BD.Cart.Queue.Items);
};
BD.Cart.Queue.Process = function() {
	if (BD.Cart.Queue.Items.length) {
		var items_count = BD.Cart.Queue.Items.length;
		var item = BD.Cart.Queue.Items.shift();
		console.log("BD.Cart.Queue.Process (" + items_count + "): " + item.url);
		//console.table(item.data);
		BD.Cart.Queue.XHR(item);
	} else {
		console.log("BD.Cart.Queue.Process: Done - Reload Cart View");
		if ($(".cart-inner-content")) {
			$.get("/cart?view=json", function(result) {
				$(".cart-inner-content").html(result);
			});
            // Extend - Dispatch event
            window.setTimeout(function() {window.dispatchEvent(new Event('refreshAjaxCart'))}, 100)
            // Extend - End code
		}
		if ($("#cart_fieldset").length) {
			$.get("/cart?view=checkout", function(result) {
				$("#cart_fieldset").html(result);
				BD.Cart.Quantity.Init();
			});
		}
		if ($("#cart_page_totals")) {
			$.get("/cart?view=totals", function(result) {
				$("#cart_page_totals").html(result);
			});
		}
		if ($("[data-discount-add]").length) {
			//console.log("[data-discount-add]: Done");
			BD.Cart.Discount.Done();
		}
		$.getJSON("/cart.js", function(result) {
			//$(".cart-total .cart-qty").html(result.item_count);
			var item_count = 0;
			result.items.forEach(function(item) {
				if (item.product_type !== "Core Deposit") {
					item_count += item.quantity;
				}
			});
			$(".cart-total .cart-qty").html(item_count);

			// Enable Cart fieldset if it is currently rendered in page
			var cart_fieldset = document.getElementById("cart_fieldset");
			if (cart_fieldset) {
				cart_fieldset.disabled = false;
			}
		});

      	//BD.Cart.Persist.Current.Set();
      
	}
};
BD.Cart.Queue.XHR = function(item) {
	$.ajax({
		type: 'POST',
		url: item.url,
		dataType: 'json',
		data: item.data,
		success: function(res) {
			if (BD.Cart.Queue.Items.length) {
				//BD.Cart.Queue.Process();
			} else {
				console.log("success: BD.Cart.Queue.XHR");
			}
		},
		error: function() {
			if (BD.Cart.Queue.Items.length) {
				//BD.Cart.Queue.Process();
			} else {
				console.log("error: BD.Cart.Queue.XHR");
			}
		}
	}).done(function() {
		if (BD.Cart.Queue.Items.length) {
			console.log("done: BD.Cart.Queue.XHR: Done - Go to next item");
			BD.Cart.Queue.Process();
		} else {
			console.log("done: BD.Cart.Queue.XHR: Done - Go to Reload Cart View");
			BD.Cart.Queue.Process();
		}
	});
};

//----------------------------------------------------
// BD Cart Quantity Methods
//----------------------------------------------------
BD.Cart.Quantity = {};
BD.Cart.Quantity.Init = function() {
	console.log("BD.Cart.Quantity.Init");
	var buttons = document.querySelectorAll("[data-change]");
	[].forEach.call(buttons, function(button) {
		button.addEventListener("click", function(event) {
			event.stopPropagation();
			event.preventDefault();
			var target = event.target || event.toElement;
			if (target.tagName == "BUTTON") {
				BD.Cart.Quantity.Change(target);
			} else {
				target = target.parentNode;
				BD.Cart.Quantity.Change(target);
			}
		});
	});
};
BD.Cart.Quantity.Change = function(target) {
	if (target.dataset && target.dataset.change && target.dataset.line) {
		var cart_fieldset = document.getElementById("cart_fieldset");
		cart_fieldset.disabled = true;

		var item_change = target.dataset.change;
		var item_line = target.dataset.line;
		var item_input = document.querySelector("[data-change='" + item_line + "']");
		var item_key = item_input.dataset.key;
		var item_qty = parseInt(item_input.value, 10);

		switch (item_change) {
			case "plus":
				item_qty = isNaN(item_qty) ? 0 : item_qty;
				item_qty++;
				item_input.value = item_qty;
				break;
			case "minus":
				item_qty = isNaN(item_qty) ? 0 : item_qty;
				item_qty--;
				item_qty = item_qty < 1 ? 0 : item_qty;
				item_input.value = item_qty;
				break;
			case "remove":
				item_qty = 0;
				break;
		}

		BD.Cart.Queue.Items = [];

		var item = {
			url: "/cart/change.js",
			data: "id=" + item_key + "&quantity=" + item_qty
		};

		BD.Cart.Queue.Add(item);
		BD.Cart.Queue.Process();

		//console.log("item_change: " + item_change + " | item_line: " + item_line + " | item_qty: " + item_qty + " | item_key: " + item_key);
	}
};

document.addEventListener("DOMContentLoaded", function() {
	BD.Cart.Quantity.Init();
}, false);

//----------------------------------------------------
// BD Cart Discount Methods
//----------------------------------------------------
BD.Cart.Discount = {};
BD.Cart.Discount.Init = function() {
	console.log("BD.Cart.Discount.Init");
	var buttons = document.querySelectorAll("[data-discount-add]");
	[].forEach.call(buttons, function(button) {
		button.addEventListener("click", function(event) {
			event.stopPropagation();
			event.preventDefault();
			var target = event.target || event.toElement;
			if (target.tagName == "BUTTON") {
				BD.Cart.Discount.Add(target);
			} else {
				target = target.parentNode;
				BD.Cart.Discount.Add(target);
			}
		});
	});

	buttons = document.querySelectorAll("[data-discount-all]");
	[].forEach.call(buttons, function(button) {
		button.addEventListener("click", function(event) {
			event.stopPropagation();
			event.preventDefault();
			var target = event.target || event.toElement;
			if (target.tagName == "BUTTON") {
				BD.Cart.Discount.All(target);
			} else {
				target = target.parentNode;
				BD.Cart.Discount.All(target);
			}
		});
	});
};
BD.Cart.Discount.Done = function() {
	console.log("BD.Cart.Discount.Done");
	var changed = false;
	var buttons = document.querySelectorAll("[data-discount-add],[data-discount-all]");
	[].forEach.call(buttons, function(button) {
		if (button.disabled === true) {
			changed = true;
		}
		button.disabled = false;
	});

	if (changed) {
		if (cartData.shopping_cart_action == 'widget') {
			if ($('.header-container').hasClass('sticky-header')) {
				$('.main-top-nav .mini-cart .cart-wrapper').fadeIn(200);
			} else {
				$('.mini-cart .cart-wrapper').fadeIn(200);
			}

			timeoutNumber = setTimeout(function() {
				$('.mini-cart .cart-wrapper').fadeOut(200);
			}, 3500);
		}
	}
};
BD.Cart.Discount.Success = function() {
	console.log("BD.Cart.Discount.Success");
	var _snackbar = document.getElementById("snackbar");

	var _html = '<div class="alert bg-success text-white alert-dismissible fade show mb-0 border-top-0 border-right-0 border-left-0" role="alert" style="opacity: 0.98;">';
	_html += '<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>';
	_html += '<h5 class="alert-heading">CONGRATULATIONS!</h5>';
	_html += '<p class="mb-0"><i class="fas fa-fw fa-check text-success"></i> BUNDLE ITEM ADDED TO CART...<br /><strong>ENJOY YOUR SAVINGS!</strong></p>';
	_html += '</div>';

	var template = document.createElement('template');
	_html = _html.trim(); // Never return a text node of whitespace as the result
	template.innerHTML = _html;
	var _alert = template.content.firstChild;

	setTimeout(function() {
		$(_alert).alert('close');
	}, 3500);

	_snackbar.appendChild(_alert);
};
BD.Cart.Discount.Add = function(target) {
	if (target.dataset && target.dataset.discountAdd) {
		target.disabled = true;

		var item_id = target.dataset.discountAdd;
		var item_qty = 1;

		BD.Cart.Queue.Items = [];

		var item = {
			url: "/cart/add.js",
			data: "id=" + item_id + "&quantity=" + item_qty
		};

		BD.Cart.Queue.Add(item);
		BD.Cart.Queue.Process();

		console.log("BD.Cart.Discount.Add() | item_id: " + item_id + " | item_qty: " + item_qty);
	}
};
BD.Cart.Discount.All = function(target) {
	if (target.dataset && target.dataset.discountAll) {
		target.disabled = true;

		BD.Cart.Queue.Items = [];

		var item_ids = target.dataset.discountAll;
		var item_qty = 1;

		item_ids.split(",").forEach(function(item_id) {
			var item = {
				url: "/cart/add.js",
				data: "id=" + item_id + "&quantity=" + item_qty
			};

			BD.Cart.Queue.Add(item);

			console.log("BD.Cart.Discount.All() | item_id: " + item_id + " | item_qty: " + item_qty);
		});

		BD.Cart.Queue.Process();
	}
};

document.addEventListener("DOMContentLoaded", function() {
	BD.Cart.Discount.Init();
}, false);

//----------------------------------------------------
// BD Cart Discount Offers Methods
//----------------------------------------------------
BD.Cart.Discount.Offers = {};
BD.Cart.Discount.Offers.Init = function() {
	console.log("BD.Cart.Discount.Offers.Init");
	var cart_items = [];
	var inputs = document.getElementsByName("updates[]");
	[].forEach.call(inputs, function(input) {
		var data_key = input.dataset.key.split(":");
		var data_sku = input.dataset.sku;
		cart_items.push({
			"variant_id": data_key[0],
			"variant_sku": data_sku,
			"variant_qty": input.value
		});
	});

	console.log(cart_items);

	if (cart_items.length) {
		BD.Cart.Discount.Offers.Request(cart_items);
	}
};
BD.Cart.Discount.Offers.Request = function(cart_items) {
	var formData = new FormData();

	formData.append("selected_action", "discount_offers");
	formData.append("website_name", Shopify.shop.replace(".myshopify.com", ""));
	formData.append("cart_items", JSON.stringify(cart_items));

	var xhr = new XMLHttpRequest();
	xhr.onreadystatechange = function() {
		if (xhr.readyState == 4) {
			try {
				//console.log(xhr.responseText);
				eval(xhr.responseText);
			} catch (e) {
				alert(e);
			}
		}
	};

	xhr.open("POST", "https://shopify.bddiesel.com/php/shopify.xhr.discount.offers.php");
	xhr.send(formData);
};

document.addEventListener("DOMContentLoaded", function() {
	//BD.Cart.Discount.Offers.Init();
}, false);

//----------------------------------------------------
// BD Cart Persist Methods
//----------------------------------------------------
BD.Cart.Persist = {};
BD.Cart.Persist.Days = 7;
BD.Cart.Persist.Items = [];
BD.Cart.Persist.Cookie = {};
BD.Cart.Persist.Cookie.Get = function(name) {
	var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
	return v ? v[2] : null;
}
BD.Cart.Persist.Cookie.Set = function(name, value, days) {
	var d = new Date;
	d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
	document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString() + ";domain=myshopify.com";
	//document.cookie = "myValuex=" + JSON.stringify(value) + ";path=/;domain=myshopify.com";
	//document.cookie = "myValuey=" + window.btoa(JSON.stringify(value)) + ";path=/;domain=myshopify.com";
}
BD.Cart.Persist.Cookie.Delete = function(name) {
	BD.Cart.Persist.Cookie.Set(name, '', -1);
}
BD.Cart.Persist.Current = {};
BD.Cart.Persist.Current.Set = function() {
	const url = "/cart.js";
	fetch(url)
		.then((resp) => resp.json())
		.then(function(data) {
			let items = data.items;

			var item_data = "";
			var items_list = [];
			var items_data = "";

			items.forEach((item) => {
				item_data = item.quantity + "," + item.sku + (typeof item.properties.parent_sku === "undefined" ? "" : "," + item.properties.parent_sku);
				items_list.push(item_data);
			});

			items_data = items_list.join("|");
			console.log("items_data:", items_data);

			BD.Cart.Persist.Cookie.Set(Shopify.shop.replace(".myshopify.com", "") + "-cart", items_data, BD.Cart.Persist.Days);
			//BD.Cart.Persist.Cookie.Delete(Shopify.shop.replace(".myshopify.com", "") + "-cart");

			return true;
		})
		.catch(function(error) {
			console.log(error);
			return false;
		});
};
BD.Cart.Persist.Current.Get = function() {

};
